// extracted by mini-css-extract-plugin
module.exports = {"CarouselHeroCard":"CarouselHeroCard_CarouselHeroCard__VworI"};